import { apiSignInExternos } from '@/library/api/auth';
import { Auth, API, Logger } from 'aws-amplify'
const logger = new Logger('CREDENCIALES.SIIMPLE', 'INFO')

class CredencialesExternas {
	constructor(storage, config={}){
		this._storage = storage;
		this._rut = undefined;
	}
	get storage(){	return this._storage;	}
	async validarSesion(){}
	getCredenciales(){}
	async iniciarSesion(){}
	onSignInError(){}
}

export class CredencialesSIImple extends CredencialesExternas {
	constructor(){
		super()
		this._userData = undefined;
		this._rut = undefined;
	}

	get userData(){	return this._userData;	}
	set userData(val){	this._userData = val	};

	get rut(){
		if( this.userData )	return this.userData.rut;
		else return undefined;
	}

	getCredenciales(){
		let creds = this.storage.jwt;
		return creds;
	}

	async configurarSesion(){
		try{
			logger.info('configurando sesion')
			await this.validarSesion();
		}catch(e){
			logger.warn('no se ha encontrado una sesion valida')
			throw e;
		}
	}
	/**
	 * 
	 * @param {string} token openid token generado por nosotros para la sesion de amplify 
	 * @param {string} identity_id identity id otorgada por nosotros
	 * @param {number} expires_at timestamp de cuando expira la sesion, al expirar la sesion las credenciales de amplify seran borradas e intentara volver a iniciar sesion. 
	 * 
	 * return ?
	 */
	async iniciarSesion({token, identity_id, expires_at}, user={}){
		try{
			logger.info('iniciando sesion', token, identity_id, expires_at)
			let authPayload = { token, identity_id, expires_at }
			const userData = { ...user, expiresAt: expires_at }

			userData.rut = userData.username;
			this.userData = userData;

			const cred = await Auth.federatedSignIn( 'developer', authPayload, userData );

			logger.info('usuario logeado, retornando', cred)
			return cred;
		}catch(e){
			// ?
			logger.error('PROBLEMAS LOGEANDO', e)
			throw e;
		}
	}
	async validarSesion(){
		logger.info('validando sesion')
		let r = await apiSignInExternos()
		logger.info('sesion validada', r)

		const expires_at = new Date().getTime() + r.user.expires_in
		return await this.iniciarSesion(
			r.openId.Token
			, r.openId.IdentityId
			, expires_at
			, r.user
		)
	}
}